/**
 * Resolves a user-supplied `next` value to an in-app path, or "/" if it does
 * not stay on `origin`.
 *
 * Parsing with `new URL` rather than prefix checks matters: browsers treat
 * `/\evil.example` and `/<tab>/evil.example` as `//evil.example`, which a
 * `startsWith("/")` test lets through.
 */
export function safeRedirectPath(next, origin) {
  if (!next) return "/";
  let url;
  try {
    url = new URL(next, origin);
  } catch {
    return "/";
  }
  if (url.origin !== origin) return "/";
  const path = url.pathname + url.search + url.hash;
  // `/.//evil.example` normalises to `//evil.example`, which assign() would
  // read as a protocol-relative URL even though the origin check passed.
  return path.startsWith("//") ? "/" : path;
}